var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"https://res.cloudinary.com/revcascade/image/upload/f_auto,w_400/static/logo.png","width":"200"}})
}
var staticRenderFns = []

export { render, staticRenderFns }